import { render, staticRenderFns } from "./planData.vue?vue&type=template&id=17f1c2e7&"
import script from "./planData.vue?vue&type=script&lang=js&"
export * from "./planData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports